import React from 'react';
import { Drawer } from 'antd';
import ProcessProgressMonitor from '../Common/ProcessProgressMonitor';
import { useBreakpointScreens } from '../../hooks/useBreakpointScreens';

export const OPEN_PROCESS_MONITOR_EVENT = 'mb_open_process_monitor';

export function openProcessMonitorDrawer() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(OPEN_PROCESS_MONITOR_EVENT));
  }
}

const ImportMonitorDrawer = ({ open, onClose }) => {
  const screens = useBreakpointScreens();
  const isMobile = !screens.md;

  return (
    <Drawer
      title="Мониторинг процессов"
      placement={isMobile ? 'bottom' : 'right'}
      height={isMobile ? '92%' : undefined}
      width={isMobile ? '100%' : 720}
      onClose={onClose}
      open={open}
      destroyOnClose
      styles={{
        body: {
          padding: isMobile ? 12 : 16,
          overflowX: 'hidden',
          overflowY: 'auto'
        },
        wrapper: isMobile ? { maxWidth: '100vw' } : undefined
      }}
    >
      <ProcessProgressMonitor refreshInterval={4000} embedded />
    </Drawer>
  );
};

export default ImportMonitorDrawer;
